import { canUseTrackingTool } from './trackingToolValidate'

// event名を必ず指定して使ってください
export function callDataLayer(params) {
  if (process.env.NODE_ENV !== 'production') return
  if (!canUseTrackingTool()) return
  return new Promise(resolve => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      eventCallback: () => {
        resolve()
      },
      ...params,
    })
  })
}
